<template>
  <div>
    <div class="flex" v-if="!isLessonTab">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <!-- <pre>{{ courseDetailInfo }}</pre> -->
        <div v-if="loading" class="flex items-center justify-center heightfix">
          <img src="@/assets/newd/loading.gif" alt="" />
        </div>
        <div
          class="p-5 lg:p-10 flex flex-col gap-10"
          v-else-if="courseDetailInfo"
        >
          <div class="flex flex-col lg:flex-row items-start gap-10">
            <div class="w-full lg:w-[50%]">
              <video
                v-if="courseDetailInfo[0]?.video_url"
                :src="fixUrl(courseDetailInfo[0].video_url)"
                class="rounded-2xl h-[300px] object-cover w-full"
                controls
                playsinline
              ></video>
              <img
                v-else-if="courseDetailInfo[0].thumbnail"
                :src="courseDetailInfo[0].thumbnail"
                class="rounded-2xl h-[300px] object-cover w-full"
              />
            </div>

            <div class="flex flex-col gap-3 lg:w-[50%] mt-10 w-full">
              <h1 class="text-lg lg:text-xl text-primary font-bold">
                {{ courseDetailInfo[0].title }}
              </h1>

              <div class="flex items-center gap-10">
                <div class="flex items-center rounded-2xl py-3 gap-2">
                  <img src="@/assets/new/rounded.png" alt="" />
                  <p class="text-xs font-bold">
                    {{ courseDetailInfo[0].sections.length }} Units
                  </p>
                </div>
                <div
                  class="flex items-center rounded-2xl py-3 gap-2"
                  v-if="courseDetailInfo[0].total_contact_hours"
                >
                  <img src="@/assets/new/time.png" alt="" />
                  <p class="text-xs font-bold">
                    {{ courseDetailInfo[0].total_contact_hours.slice(0, -3) }}
                    hours
                  </p>
                </div>
              </div>

              <div>
                <!-- {{ this.lessonInfo.results }} -->
                <!-- <button v-if="this.lessonInfo.results"
                  class="bg-blues text-white font-semibold rounded-full py-2 px-5 text-xs"
                  @click="
                    setUrlTap(
                      this.lessonInfo.results[0].video_url,
                      0,
                      this.lessonInfo.results[0]
                    )
                  "
                >
                  Continue Learning
                </button> -->
                <button
                  v-if="isLessonLoading"
                  class="text-gray-400 font-semibold rounded-full py-2 text-xs"
                  disabled
                >
                  Loading...
                </button>

                <router-link
                  v-else-if="
                    lessonInfo &&
                    lessonInfo.results &&
                    lessonInfo.results.length
                  "
                  :to="{
                    name: 'LessonView',
                    params: {
                      lesson_id: lessonInfo.results[0].id,
                      title: courseDetailInfo[0].title,
                    },
                  }"
                  class="bg-blues text-white font-semibold rounded-full py-2 px-5 text-xs"
                >
                  Continue Learning
                </router-link>

                <button
                  v-else
                  class="text-blues font-semibold rounded-full py-2 text-xs"
                >
                  No Lessons
                </button>
              </div>

              <div class="flex items-center justify-between w-full">
                <div>
                  <p
                    class="text-sm"
                    v-if="percentage.completion_percentage < 100"
                  >
                    In progress
                  </p>
                  <p v-else class="text-sm">Complete</p>
                </div>
                <div>
                  <p class="text-sm">{{ percentage.completion_percentage }}%</p>
                </div>
              </div>

              <div class="relative w-full bg-gray-200 rounded-full h-4">
                <div
                  class="absolute left-0 top-0 h-4 bg-blues rounded-full transition-all duration-300"
                  :style="{ width: percentage.completion_percentage + '%' }"
                ></div>
              </div>
            </div>
          </div>

          <div class="flex flex-col gap-4 px-2 hidden">
            <table class="mt-6 w-full">
              <tbody>
                <tr>
                  <th style="text-align: left !important">Course Title</th>
                  <td style="text-align: left !important">
                    {{ courseDetailInfo[0].title }}
                  </td>
                  <th style="text-align: left !important">Semester</th>
                  <td style="text-align: left !important">
                    {{ courseDetailInfo[0].semester.semester }}
                  </td>
                </tr>
                <tr>
                  <th style="text-align: left !important">Course Code</th>
                  <td style="text-align: left !important">
                    {{ courseDetailInfo[0].course_code }}
                  </td>
                  <th style="text-align: left !important">CIE</th>
                  <td style="text-align: left !important">
                    {{ courseDetailInfo[0].cie }}
                  </td>
                </tr>
                <tr>
                  <th style="text-align: left !important">
                    Total No. of Contact Hours
                  </th>
                  <td style="text-align: left !important">
                    {{ courseDetailInfo[0].total_contact_hours }}
                  </td>
                  <th style="text-align: left !important">SEE</th>
                  <td style="text-align: left !important">
                    {{ courseDetailInfo[0].see }}
                  </td>
                </tr>
                <tr>
                  <th style="text-align: left !important">
                    No. of Contact Hours/Week
                  </th>
                  <td style="text-align: left !important">
                    {{ courseDetailInfo[0].no_of_contact_hours }}
                  </td>
                  <th style="text-align: left !important">Total</th>
                  <td style="text-align: left !important">
                    {{ courseDetailInfo[0].total }}
                  </td>
                </tr>
                <tr>
                  <th style="text-align: left !important">Credits</th>
                  <td style="text-align: left !important">
                    {{ courseDetailInfo[0].credits }}
                  </td>
                  <th style="text-align: left !important">Exam. Duration</th>
                  <td style="text-align: left !important">
                    {{ courseDetailInfo[0].exam_duration?.slice(0, -3) }}
                  </td>
                </tr>
                <tr>
                  <th style="text-align: left !important" colspan="1">
                    Teaching Dept
                  </th>
                  <td style="text-align: left !important" colspan="3">
                    {{ courseDetailInfo[0].department.name }}
                    <!-- <div v-for="(semester, index) in courseDetailInfo[0].semesters" :key="index" class="flex">
                        {{ semester.department.name }},
                      </div> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="flex flex-col gap-4 px-2">
            <h2 class="text-lg text-primary font-bold">Course objective :</h2>

            <p class="text-sm">
              {{ this.courseDetailInfo[0].short_description }}
            </p>
          </div>

          <div class="flex flex-col gap-4 px-2">
            <h2 class="text-lg text-primary font-bold">Description</h2>

            <p
              v-html="this.courseDetailInfo[0].description"
              class="text-sm"
            ></p>
          </div>

          <div class="flex flex-col gap-10 px-2">
            <h2 class="text-lg text-primary font-bold">Course Content</h2>
            <div class="flex flex-col gap-4">
              <div v-for="section in sectionInfo.data" :key="section">
                <div
                  class="bg-blues flex items-center rounded-2xl px-10 py-1 gap-5 justify-between cursor-pointer"
                  @click="courseSectionToggle(section.id)"
                >
                  <div class="flex gap-2">
                    <div
                      v-if="section.section_participant.status == true"
                      class="flex items-center rounded-2xl py-2 gap-3 cursor-pointer"
                    >
                      <!-- <div
                        class="w-[10px] h-[10px] bg-black rounded-full"
                      ></div> -->
                      <div class="w-[16px]">
                        <img
                          src="@/assets/mdi_tick-circle-outline.png"
                          class="object-cover w-4 h-4 font-semibold"
                        />
                      </div>
                      <!-- <p
                        class="text-sm py-1"
                        :class="{
                          'text-blues font-bold': activeIndex === index,
                          'text-black': activeIndex !== index,
                        }"
                      >
                        {{ lesson.title }}
                      </p> -->
                    </div>
                    <div
                      v-else
                      class="flex items-center rounded-2xl py-2 gap-3 cursor-pointer"
                    >
                      <div class="w-[16px]">
                        <!-- <div
                          class="w-[12px] mx-auto h-[12px] rounded-full border-2"
                          :class="{
                            ' bg-blue-400 border-blue-500 border-none':
                              activeIndex === index,
                            'border-[#7c7d7f] ': activeIndex !== index,
                          }"
                        ></div> -->
                        <p v-if="section.file_type == 'video'">🎥</p>
                        <p v-if="section.file_type == 'download'">⬇️</p>
                        <p v-if="section.file_type == 'document'">📄</p>
                        <p v-if="section.file_type == 'pdf'">📕</p>
                        <p v-if="section.file_type == 'word'">📘</p>
                        <p v-if="section.file_type == 'general'">⚫</p>
                      </div>
                      <!-- <p
                        class="text-sm py-1"
                        :class="{
                          'text-blues font-bold': activeIndex === index,
                          'text-black': activeIndex !== index,
                        }"
                      >
                        {{ lesson.title }}
                      </p> -->
                    </div>

                    <p class="font-bold text-sm py-3 text-white">
                      {{ section.title }}
                    </p>
                  </div>

                  <div class="flex items-center gap-5">
                    <!-- 
                    <p class="font-bold text-sm py-3 text-white flex items-center gap-4" v-if="section.rbt_levels != null">
                      RBT Levels: {{ section.rbt_levels }} 
                  </p> -->

                    <p
                      class="font-bold text-sm py-3 text-white"
                      v-if="section.rbt_levels != null"
                    >
                      Duration: {{ section.duration.slice(0, -3) }}
                    </p>

                    <img
                      src="@/assets/new/upw.png"
                      v-if="activeCourseMenu == section.id"
                      style="height: 8px !important"
                      alt=""
                    />
                    <img
                      src="@/assets/new/downw.png"
                      v-if="activeCourseMenu != section.id"
                      style="height: 8px !important"
                      alt=""
                    />
                  </div>
                </div>

                <div
                  v-if="activeCourseMenu == section.id"
                  v-for="(lesson, index) in lessonInfo.results"
                  :key="lesson"
                >
                  <div
                    class="my-5 flex flex-col gap-4"
                    v-if="section.id == lesson.section_id"
                  >
                    <router-link
                      :to="{
                        name: 'LessonView',
                        params: {
                          lesson_id: lesson.id,
                          title: courseDetailInfo[0].title,
                        },
                      }"
                      v-if="lesson.section_participant.status == true"
                      class="bg-gray-200 flex items-center rounded-2xl px-10 py-2 gap-3 cursor-pointer"
                    >
                      <div class="w-[16px]">
                        <img
                          src="@/assets/mdi_tick-circle-outline.png"
                          class="object-cover w-4 h-4 font-semibold"
                        />
                      </div>
                      <p
                        class="text-sm py-1"
                        :class="{
                          'text-blues font-bold': activeIndex === index,
                          'text-black': activeIndex !== index,
                        }"
                      >
                        {{ lesson.title }}
                      </p>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'LessonView',
                        params: {
                          lesson_id: lesson.id,
                          title: courseDetailInfo[0].title,
                        },
                      }"
                      v-else
                      class="bg-gray-200 flex items-center rounded-2xl px-10 py-2 gap-3 cursor-pointer"
                    >
                      <div class="w-[16px]">
                        <p v-if="lesson.file_type == 'video'">🎥</p>
                        <p v-if="lesson.file_type == 'download'">⬇️</p>
                        <p v-if="lesson.file_type == 'document'">📄</p>
                        <p v-if="lesson.file_type == 'pdf'">📕</p>
                        <p v-if="lesson.file_type == 'word'">📘</p>
                        <p v-if="lesson.file_type == 'general'">⚫</p>
                      </div>
                      <p
                        class="text-sm py-1"
                        :class="{
                          'text-blues font-bold': activeIndex === index,
                          'text-black': activeIndex !== index,
                        }"
                      >
                        {{ lesson.title }}
                      </p>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="flex flex-col gap-4 px-2">
           
            <div>
              <h1 class="text-lg font-semibold ">CO PO PSO MAPPING</h1>
            </div>

              <table class="mt-6 w-full"> 
                <thead> 
                  <tr> 
                    <th>CO</th>
                    <th style="text-align: left !important;">Course outcomes: Ability to</th>
                   
                  </tr>
                </thead>
                <tbody> 
                  <tr v-for="i in coGet" :key="i">
                    <td>{{ i.title }}</td>
                    <td style="text-align: left !important;">{{ i.description }}</td>
                  </tr>
                </tbody>
              </table>
          </div>

          <div class="flex flex-col gap-4 px-2">

            <div>
              <h1 class="text-lg font-semibold ">CO PO PSO MAPPING</h1>
            </div>

            <table class="mt-6 w-full"> 
              <thead> 
                <tr> 
                  <th>CO / PO</th>
                  <th v-for="i in 12" :key="i">PO {{ i }}</th>
                  <th v-for="i in 3" :key="i">PSO {{ i }}</th>
                </tr>
              </thead>
              <tbody> 
                <tr v-for="i in pso.length" :key="i">
                  <td>{{ pso[i-1].co }}</td>
                  <td v-for="i in pso[i-1].po_mappings" :key="i">{{ i.mark }}</td>
                  <td v-for="i in pso[i-1].pso_mappings" :key="i"> {{ i.mark }}</td>
                </tr>
              </tbody>
            </table> 

            <p class="px-1 py-3 text-sm">High-3, Medium-2, Low-1</p>

          </div> -->
        </div>
        <div v-else class="flex justify-center heightfix items-center">
          No Data found
        </div>
      </div>
    </div>

    <div class="flex" v-if="isLessonTab">
      <div
        class="lg:flex fixed w-[80%] bg-white lg:w-[35%] xl:w-[30%] 2xl:w-[25%] lg:relative z-[60] m-10 px-5 py-10 rounded-3xl"
        :class="{ hidden: !isMobile }"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div>
          <div
            class="flex flex-col gap-5 relative w-full overflow-y-auto heighttab"
          >
            <router-link
              :to="{ name: 'StudentCourseProgress' }"
              class="flex items-center gap-5 p-4 rounded-3xl"
              :class="{
                'bg-[#0085DB]': $route.name == 'StudentCourseProgress',
              }"
            >
              <img
                src="@/assets/newd/icons/Grid.png"
                v-if="$route.name == 'StudentCourseProgress'"
                alt=""
              />
              <img
                src="@/assets/newd/icons/Grid-1.png"
                v-if="$route.name != 'StudentCourseProgress'"
                alt=""
              />
              <!-- <p
              class="font-bold text-sm"
              :class="{
                'text-white': $route.name == 'StudentCourseProgress',
                'text-[#333333]': $route.name != 'StudentCourseProgress',
              }"
            >
              Lessons
            </p> -->
            </router-link>

            <router-link
              :to="{ name: 'StudentMessages' }"
              class="flex items-center gap-5 p-4 rounded-3xl"
              :class="{ 'bg-[#0085DB]': $route.name == 'StudentMessages' }"
            >
              <img
                src="@/assets/newd/icons/mdi-light_forum-1.png"
                v-if="$route.name == 'StudentMessages'"
                alt=""
              />
              <img
                src="@/assets/newd/icons/mdi-light_forum.png"
                v-if="$route.name != 'StudentMessages'"
                alt=""
              />

              <!-- <p
              class="font-bold text-sm"
              :class="{
                'text-white': $route.name == 'StudentMessages',
                'text-[#333333]': $route.name != 'StudentMessages',
              }"
            >
              Messages
            </p> -->
            </router-link>

            <router-link
              :to="{ name: 'StudentAssignments' }"
              class="flex items-center gap-5 p-4 rounded-3xl"
              :class="{ 'bg-[#0085DB]': $route.name == 'StudentAssignments' }"
            >
              <img
                src="@/assets/newd/icons/gg_notes-1.png"
                v-if="$route.name == 'StudentAssignments'"
                alt=""
              />
              <img
                src="@/assets/newd/icons/gg_notes.png"
                v-if="$route.name != 'StudentAssignments'"
                alt=""
              />
              <!-- <p
              class="font-bold text-sm"
              :class="{
                'text-white': $route.name == 'StudentAssignments',
                'text-[#333333]': $route.name != 'StudentAssignments',
              }"
            >
              Assignments
            </p> -->
            </router-link>
            <!-- old forums -->
            <router-link
              :to="{ name: 'StudentForums' }"
              class="flex items-center gap-5 p-4 rounded-3xl hidden"
              :class="{ 'bg-[#0085DB]': $route.name == 'StudentForums' }"
            >
              <img
                src="@/assets/newd/icons/Archive-1.png"
                v-if="$route.name == 'StudentForums'"
                alt=""
              />
              <img
                src="@/assets/newd/icons/Archive.png"
                v-if="$route.name != 'StudentForums'"
                alt=""
              />

              <!-- <p
              class="font-bold text-sm"
              :class="{
                'text-white': $route.name == 'StudentForums',
                'text-[#333333]': $route.name != 'StudentForums',
              }"
            >
              Forums
            </p> -->
            </router-link>

            <!-- new forums -->
            <router-link
              :to="{ name: 'StudentNewForums' }"
              class="flex items-center gap-5 p-4 rounded-3xl"
              :class="{ 'bg-[#0085DB]': $route.name == 'StudentNewForums' }"
            >
              <img
                src="@/assets/newd/icons/Archive-1.png"
                v-if="$route.name == 'StudentNewForums'"
                alt=""
              />
              <img
                src="@/assets/newd/icons/Archive.png"
                v-if="$route.name != 'StudentNewForums'"
                alt=""
              />

              <!-- <p
              class="font-bold text-sm"
              :class="{
                'text-white': $route.name == 'StudentNewForums',
                'text-[#333333]': $route.name != 'StudentNewForums',
              }"
            >
              Forums
            </p> -->
            </router-link>

            <router-link
              :to="{ name: 'StudentClasses' }"
              class="flex items-center gap-5 p-4 rounded-3xl"
              :class="{ 'bg-[#0085DB]': $route.name == 'StudentClasses' }"
            >
              <img
                src="@/assets/newd/icons/Calendar2Week-1.png"
                v-if="$route.name == 'StudentClasses'"
                alt=""
              />
              <img
                src="@/assets/newd/icons/Calendar2Week.png"
                v-if="$route.name != 'StudentClasses'"
                alt=""
              />

              <!-- <p
              class="font-bold text-sm"
              :class="{
                'text-white': $route.name == 'StudentClasses',
                'text-[#333333]': $route.name != 'StudentClasses',
              }"
            >
              Live Classes
            </p> -->
            </router-link>

            <router-link
              :to="{ name: 'StudentAssessments' }"
              class="flex items-center gap-5 p-4 rounded-3xl"
              :class="{ 'bg-[#0085DB]': $route.name == 'StudentAssessments' }"
            >
              <img
                src="@/assets/newd/icons/BarChartLine-1.png"
                v-if="$route.name == 'StudentAssessments'"
                alt=""
              />
              <img
                src="@/assets/newd/icons/BarChartLine.png"
                v-if="$route.name != 'StudentAssessments'"
                alt=""
              />

              <!-- <p
              class="font-bold text-sm"
              :class="{
                'text-white': $route.name == 'StudentAssessments',
                'text-[#333333]': $route.name != 'StudentAssessments',
              }"
            >
              Assessment
            </p> -->
            </router-link>

            <router-link
              :to="{ name: 'StudentReport' }"
              class="flex items-center gap-5 p-4 rounded-3xl"
              :class="{ 'bg-[#0085DB]': $route.name == 'StudentReport' }"
            >
              <img
                src="@/assets/newd/icons/CloudArrowDown-1.png"
                v-if="$route.name == 'StudentReport'"
                alt=""
              />
              <img
                src="@/assets/newd/icons/CloudArrowDown.png"
                v-if="$route.name != 'StudentReport'"
                alt=""
              />

              <!-- <p
              class="font-bold text-sm"
              :class="{
                'text-white': $route.name == 'StudentReport',
                'text-[#333333]': $route.name != 'StudentReport',
              }"
            >
              Reports
            </p> -->
            </router-link>

            <router-link
              :to="{ name: 'StudentProject' }"
              class="flex items-center gap-5 p-4 rounded-3xl"
              :class="{ 'bg-[#0085DB]': $route.name == 'StudentProject' }"
            >
              <img
                src="@/assets/newd/icons/gg_notes-1.png"
                v-if="$route.name == 'StudentProject'"
                alt=""
              />
              <img
                src="@/assets/newd/icons/gg_notes.png"
                v-if="$route.name != 'StudentProject'"
                alt=""
              />
            </router-link>
          </div>
        </div>

        <div
          v-if="courseDetailInfo"
          class="flex flex-col gap-5 relative w-full h-full overflow-y-auto heighttab"
        >
          <div v-for="section in sectionInfo.data" :key="section">
            <div
              class="text-black flex items-center rounded-2xl px-3 py-1 gap-5 justify-between cursor-pointer"
              @click="courseSectionToggle(section.id)"
            >
              <p class="font-bold text-sm py-3 text-black">
                {{ section.title }}
              </p>
              <img
                src="@/assets/new/up.png"
                v-if="activeCourseMenu == section.id"
                style="height: 6px !important"
                alt=""
              />
              <img
                src="@/assets/new/down.png"
                v-if="activeCourseMenu != section.id"
                style="height: 6px !important"
                alt=""
              />
            </div>

            <div
              v-for="(lesson, index) in lessonInfo.results"
              :key="lesson"
              v-if="activeCourseMenu == section.id"
            >
              <div
                class="my-5 flex flex-col gap-4"
                v-if="section.id == lesson.section_id"
              >
                <div
                  v-if="lesson.section_participant.status == true"
                  class="flex items-center rounded-2xl px-3 py-2 gap-3 cursor-pointer"
                  @click="setUrlTap(lesson.video_url, index, lesson)"
                >
                  <div class="w-[16px]">
                    <div class="w-[18px]">
                      <img
                        src="@/assets/mdi_tick-circle-outline.png"
                        class="object-cover w-4 h-4 font-semibold"
                      />
                    </div>
                  </div>
                  <p
                    class="text-sm py-1 pl-1"
                    :class="{ 'text-blues font-bold': activeIndex === index }"
                  >
                    {{ lesson.title }}
                  </p>
                </div>

                <div
                  v-else
                  class="flex items-center rounded-2xl px-3 py-2 gap-3 cursor-pointer"
                  @click="setUrlTap(lesson.video_url, index, lesson)"
                >
                  <div class="w-[18px]">
                    <div class="w-[16px]">
                      <p v-if="lesson.file_type == 'video'">🎥</p>
                      <p v-if="lesson.file_type == 'download'">⬇️</p>
                      <p v-if="lesson.file_type == 'document'">📄</p>
                      <p v-if="lesson.file_type == 'pdf'">📕</p>
                      <p v-if="lesson.file_type == 'word'">📘</p>
                      <p v-if="lesson.file_type == 'general'">⚫</p>
                    </div>
                  </div>
                  <p
                    class="text-sm py-1 pl-1"
                    :class="{ 'text-blues font-bold': activeIndex === index }"
                  >
                    {{ lesson.title }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="w-[90%] mx-auto lg: lg:mr-10 mt-10 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <!-- laptop -->
        <div class="hidden lg:block">
          <div class="flex items-center pt-10 px-10 justify-between">
            <button
              class="bg-blues text-xs text-white px-6 py-1.5 rounded-2xl"
              @click="isLessonTab = !this.isLessonTab"
            >
              Back
            </button>

            <h1
              class="text-lg 2xl:text-xl font-semibold w-[50%] mx-auto text-center 2xl:w-[60%] line-clamp-3"
            >
              {{ courseDetailInfo[0].title }}
            </h1>

            <div class="flex items-center gap-10">
              <div
                class="flex items-center gap-4 cursor-pointer"
                v-if="this.activeIndex != 0"
                @click="prevCourse()"
              >
                <img src="@/assets/new/left.png" class="h-3" />
                <p class="text-base">Previous</p>
              </div>
              <div
                class="flex items-center gap-4 cursor-pointer"
                v-if="this.activeIndex != this.lessonInfo.results.length - 1"
                @click="nextCourse()"
              >
                <p class="text-base">Next</p>
                <img src="@/assets/new/right.png" class="h-3" />
              </div>
            </div>
          </div>
        </div>
        <!-- mobile -->
        <div
          class="flex flex-col gap-4 items-center pt-10 px-5 justify-between block lg:hidden"
        >
          <div class="flex flex-col gap-2 justify-between w-full">
            <div class="flex justify-end">
              <button
                class="bg-blues text-xs text-white px-6 py-1.5 rounded-2xl"
                @click="isLessonTab = !this.isLessonTab"
              >
                Back
              </button>
            </div>
            <h1 class="text-lg font-semibold text-wrap">
              {{ courseDetailInfo[0].title }}
            </h1>
          </div>

          <div class="flex items-center gap-10 text-sm">
            <div
              class="flex items-center gap-4 cursor-pointer"
              v-if="this.activeIndex != 0"
              @click="prevCourse()"
            >
              <img src="@/assets/new/left.png" class="h-3" />
              <p class="text-base">Previous</p>
            </div>
            <div
              class="flex items-center gap-4 cursor-pointer"
              v-if="this.activeIndex != this.lessonInfo.results.length - 1"
              @click="nextCourse()"
            >
              <p class="text-base">Next</p>
              <img src="@/assets/new/right.png" class="h-3" />
            </div>
          </div>
        </div>

        <div class="p-5 lg:p-10 flex flex-col gap-10" v-if="selectedlessonData">
          <div class="flex flex-col gap-4">
            <div class="flex items-center justify-between w-full">
              <h1 class="text-lg lg:text-xl font-semibold">
                {{ selectedlessonData.title }}
              </h1>

              <div class="flex items-center justify-end gap-10">
                <div v-if="lessonCompletedData == null">
                  <button
                    v-if="showbutton"
                    class="bg-blues text-xs text-white block px-6 py-1.5 rounded-2xl"
                    @click="
                      completeUnit(
                        selectedlessonData.section_id,
                        selectedlessonData.id
                      )
                    "
                  >
                    Complete
                  </button>
                </div>

                <div v-else>
                  <button
                    class="bg-green-700 text-white text-xs px-4 py-2 rounded-2xl"
                  >
                    Lesson Completed
                  </button>
                </div>
              </div>
            </div>

            <div class="flex items-center gap-10">
              <div class="flex items-center rounded-2xl py-3 gap-2">
                <img src="@/assets/new/time.png" alt="" />
                <p class="text-xs pt-2">
                  {{ selectedlessonData.duration.slice(0, -3) }} min
                </p>
              </div>
            </div>
          </div>

          <div v-if="selectedlessonData.video_url != null">
            <iframe
              v-if="selectedlessonData.video_url != ''"
              class="w-full h-[600px] mx-auto rounded p-3"
              :src="selectedlessonData.video_url"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            >
            </iframe>
          </div>

          <div class="flex flex-col gap-4">
            <div
              v-html="selectedlessonData.content"
              class="w-full video-container"
            ></div>

            <iframe
              v-if="
                selectedlessonData.pdf_file != null &&
                selectedlessonData.pdf_file != ''
              "
              :src="convertHttpToHttps(selectedlessonData.pdf_file)"
              class="h-[400px]"
            ></iframe>

            <p class="text-sm">{{ selectedlessonData.keyworeds }}</p>

            <audio
              controls
              v-if="
                selectedlessonData.audio_file != null &&
                selectedlessonData.audio_file != ''
              "
            >
              <source :src="selectedlessonData.audio_file" type="audio/ogg" />
              <source :src="selectedlessonData.audio_file" type="audio/mpeg" />
              Your browser does not support the audio element.
            </audio>

            <div>
              <div v-if="selectedlessonData.quizzes">
                <div v-if="selectedlessonData.quizzes != null">
                  <div v-if="selectedlessonData.quizzes[0]">
                    <div v-if="selectedlessonData.quizzes[0].quiz.id">
                      <QuizTest
                        v-if="selectedlessonData.quizzes[0].quiz.id"
                        :key="quizKey"
                        :course_id="this.course_id"
                        :quiz_id="selectedlessonData.quizzes[0].quiz.id"
                        :taker_id="selectedlessonData.course_quiz_takers_id"
                        @pushLessonComplete="receiveLessonComplete"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/Student/SideBar.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import QuizTest from "@/views/Student/Dashboard/QuizTestComp.vue";

export default {
  components: {
    SideBar,
    QuizTest,
  },
  data() {
    return {
      messageVal: null,
      totalmessage: null,
      studentList: "",
      selectedStudent: null,
      ChatpopUp: false,
      instructorChat: [
        {
          id: "",
          display_name: "",
        },
      ],
      sectionInfo: "",
      lessonInfo: "",
      videoLink: "",
      activeIndex: null,
      isLessonTab: false,
      selectedlessonData: null,
      courseDetailInfo: null,
      progress: 90,
      activeCourseMenu: null,
      lessonCompletedData: null,
      showbutton: false,
      dataval: "",
      percentage: [],
      // new
      quiz_details: [],
      currentQuizDetails: null,
      pso: [],
      coGet: [],
      loading: true,
      isLessonLoading: true,
    };
  },

  props: ["course_id"],

  async created() {
    this.detailsgets();
    this.progressget();
    this.getPSO();

    await axios
      .get(
        `${process.env.VUE_APP_API}/co/get/${this.course_id}/?Key=${this.userInfo.token_key}`
      )
      .then((response) => {
        this.coGet = response.data.data;
      });

    await axios
      .get(
        `${process.env.VUE_APP_API}/courses/?id=${this.course_id}&Key=${this.userInfo.token_key}`
      )
      .then((response) => {
        setTimeout(() => {
          this.loading = false;
        }, 900);
        this.courseDetailInfo = response.data.data?.data?.data;
      });

    await axios
      .get(
        `${process.env.VUE_APP_API}/coursesdata/${this.course_id}/?Key=${this.userInfo.token_key}`
      )
      .then((response) => {
        this.instructorChat[0].id = response.data.user_id;
      });
  },

  mounted() {},

  computed: {
    ...mapGetters(["userInfo"]),
  },

  methods: {
    fixUrl(url) {
      if (!url) return "";
      const match = url.match(/https:\/\/.*\.mp4/);
      return match ? match[0] : url;
    },
    async getPSO() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/pso/get/${this.course_id}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.pso = response.data.data;
          } else {
            console.log("got error");
          }
        });
    },

    async quizPreview(id) {
      let token = this.userInfo.token_key;
      await axios
        .get(
          `${process.env.VUE_APP_API}/quiztaker__quizzes_pk/${id}/?Key=${token}`
        )
        .then((response) => {
          this.dataval = response.data.data;
          console.log("response::", response.data.data);
        });
    },

    convertHttpToHttps(url) {
      if (url.startsWith("http://")) {
        return url.replace("http://", "https://");
      }
      return url;
    },

    async getCompletedLesson(unit_id, lesson_id) {
      await axios
        .get(
          `${process.env.VUE_APP_API}/completed-lesson-tracking/${this.userInfo.user.id}/${lesson_id}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            // console.log(response.data.data, "data:::");
            this.lessonCompletedData = "";
          } else {
            console.log("Something went wrong::");
          }
        });
    },

    receiveLessonComplete() {
      this.completeUnit(
        this.selectedlessonData.section_id,
        this.selectedlessonData.id
      );
    },

    async completeUnitStart(unit_id, lesson_id) {
      await axios
        .post(
          `${process.env.VUE_APP_API}/lesson-tracking/${this.userInfo.user.id}/${unit_id}/${lesson_id}/?Key=${this.userInfo.token_key}`,
          {}
        )
        .then((response) => {
          if (response) {
            console.log(response);
            this.getCompletedLesson(unit_id, lesson_id);
            this.detailsgets();
            this.progressget();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async completeUnit(unit_id, lesson_id) {
      await axios
        .post(
          `${process.env.VUE_APP_API}/lesson-tracking/${this.userInfo.user.id}/${unit_id}/${lesson_id}/?Key=${this.userInfo.token_key}&status=true`,
          {}
        )
        .then((response) => {
          if (response) {
            console.log(response);
            this.getCompletedLesson(unit_id, lesson_id);
            this.detailsgets();
            this.progressget();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    courseSectionToggle(id) {
      if (this.activeCourseMenu == id) {
        this.activeCourseMenu = null;
      } else {
        this.activeCourseMenu = id;
      }
    },

    prevCourse() {
      this.showbutton = false;
      this.lessonCompletedData = null;
      this.selectedlessonData = null;
      this.quizKey++;
      if (this.activeIndex > 0) {
        this.activeIndex = this.activeIndex - 1;
        this.selectedlessonData = this.lessonInfo.results[this.activeIndex];
        this.videoLink = this.lessonInfo.results[this.activeIndex].video_url;
        this.setActiveSection();
      }
      // this.getCompletedLesson(this.selectedlessonData.id);
      this.getCompletedLesson(
        this.selectedlessonData.section_id,
        this.selectedlessonData.id
      );
      if (this.selectedlessonData.section_participant.status == null) {
        this.completeUnitStart(
          this.selectedlessonData.section_id,
          this.selectedlessonData.id
        );
      }
      setTimeout(() => {
        this.showbutton = true;
      }, this.selectedlessonData.showing_timer * 60 * 1000);
      this.getQuizDataList();
    },

    nextCourse() {
      this.showbutton = false;
      this.lessonCompletedData = null;
      this.selectedlessonData = null;
      this.quizKey++;
      if (this.activeIndex < this.lessonInfo.results.length - 1) {
        this.activeIndex = this.activeIndex + 1;
        this.selectedlessonData = this.lessonInfo.results[this.activeIndex];
        this.videoLink = this.lessonInfo.results[this.activeIndex].video_url;
        this.setActiveSection();
      }
      this.getCompletedLesson(
        this.selectedlessonData.section_id,
        this.selectedlessonData.id
      );
      if (this.selectedlessonData.section_participant.status == null) {
        this.completeUnitStart(
          this.selectedlessonData.section_id,
          this.selectedlessonData.id
        );
      }
      setTimeout(() => {
        this.showbutton = true;
      }, this.selectedlessonData.showing_timer * 60 * 1000);
      this.getQuizDataList();
    },

    setUrlTap(url, index, lesson) {
      this.showbutton = false;
      this.selectedlessonData = null;
      this.lessonCompletedData = null;
      this.quizKey++;
      this.isLessonTab = true;
      this.videoLink = url;
      this.activeIndex = index;
      this.selectedlessonData = lesson;
      this.setActiveSection();
      if (this.selectedlessonData.section_participant.status == null) {
        this.completeUnitStart(lesson.section_id, lesson.id);
      }
      // this.completeUnitStart(lesson.section_id, lesson.id);
      this.getCompletedLesson(lesson.section_id, lesson.id);

      setTimeout(() => {
        this.showbutton = true;
      }, this.selectedlessonData.showing_timer * 60 * 1000);
      this.getQuizDataList();
    },

    setUrl(url, index, lesson) {
      this.showbutton = false;
      this.selectedlessonData = null;
      this.lessonCompletedData = null;
      this.quizKey++;
      this.videoLink = url;
      this.activeIndex = index;
      this.selectedlessonData = lesson;
      this.setActiveSection();
      // this.completeUnitStart(lesson.section_id, lesson.id);
      if (this.selectedlessonData.section_participant.status == null) {
        this.completeUnitStart(lesson.section_id, lesson.id);
      }
      this.getCompletedLesson(lesson.section_id, lesson.id);
      setTimeout(() => {
        this.showbutton = true;
      }, this.selectedlessonData.showing_timer * 60 * 1000);
      this.getQuizDataList();
    },

    getQuizDataList() {
      setTimeout(() => {}, 300);
    },

    setActiveSection() {
      const activeSection =
        this.lessonInfo.results[this.activeIndex].section_id;
      this.activeCourseMenu = activeSection;
    },

    async detailsgets() {
      this.isLessonLoading = true;

      try {
        const sectionRes = await axios.get(
          `${process.env.VUE_APP_API}/section/?course_name=${this.course_id}&Key=${this.userInfo.token_key}`
        );
        this.sectionInfo = sectionRes.data;

        const lessonRes = await axios.get(
          `${process.env.VUE_APP_API}/lessons/?Key=${this.userInfo.token_key}&course_name=${this.course_id}`
        );
        this.lessonInfo = lessonRes.data;

        if (this.lessonInfo && this.lessonInfo.count) {
          this.lessonCount = this.lessonInfo.count;
        } else {
          this.lessonCount = 0;
        }
      } catch (error) {
        console.error("Error fetching lessons:", error);
        this.lessonCount = 0;
      } finally {
        this.isLessonLoading = false;
      }
    },
    async progressget() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/user-course-list-lesson-percentage/?id=${this.course_id}&Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.data) {
            this.percentage = response.data.data[0];
          }
        });
    },
  },
};
</script>

<style scoped>
td,
thead,
tr,
th {
  text-align: center;
  padding: 10px 20px;
  border: 1px solid black !important;
}

.heighttab {
  height: calc(100vh - 250px) !important;
}

.heightfix {
  height: calc(100vh - 170px) !important;
}
:deep(.video-container iframe) {
  width: 100% !important;
  height: auto !important;
  aspect-ratio: 16 / 9;
  max-height: 500px;
}
</style>
